import { OnEventArgs } from 'angular-slickgrid';
import { InterfaceElement } from '../asd/asd-properties/asd-ie/asd-interfaceElement';
import { HTMLBase } from '../html/html';

export class GridBase{
  Rows : GridRow[];
}

export class GridRow{
  RowID : number;
  Columns : GridColumn[];
}

export class GridColumn{
  ColumnID : number;
  InterfaceElements : InterfaceElement[];
}

export class GridColumnDefinition{
  id: any; 
  name: any;
  field: any; 
  type: any;
  minWidth: any;
  maxwidth: any;
  allowSort: boolean;
  allowEdit: boolean;
  cssClass: any;
  headerCssClass: any;
  cosyDataTypeID : any;
  editor: any;
  params: any;
  exportWithFormatter: any;
  width: number;
  formatter: any;
  outputType: any;
  filterable: any;
  filter: any;
  attributes: any;
  messages: any[]; 
  items:any[];
  hyperLinkValues: {LinkedHeader : any, Value: any}[];
  onCellClick?: (e: KeyboardEvent | MouseEvent, args: OnEventArgs) => void;
}
